<script>
export default {
  name: 'avaliacao-confirmacao',
  props: {
    etapa: String
  },
  data () {
    return {}
  },
  mounted () {
  },
  methods: {}
}
</script>
<template>
  <div class="avaliacao-confirmacao">
    <div class="page-content">
      <div class="page-header-content">
        <h2 class="page-title">Confirmação</h2>
      </div>
    </div>

    <div class="box pa-5">
      <div class="text-xs-center">
        <h3 class="title mb-2">Atenção candidato!</h3>
        Sua avaliação foi finalizada com sucesso.
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Confirmacao.vue?0760df76